import React from 'react';
import { cn } from '@/lib/utils';

interface CategoryPillsProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export const CategoryPills: React.FC<CategoryPillsProps> = ({
  categories,
  activeCategory,
  onCategoryChange,
}) => {
  return (
    <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide -mx-4 px-4 md:mx-0 md:px-0 md:flex-wrap md:justify-center snap-x snap-mandatory">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onCategoryChange(category)}
          className={cn(
            "flex-shrink-0 snap-start px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300",
            activeCategory === category
              ? "bg-[#00C2FF]/20 text-[#00C2FF] border border-[#00C2FF]/50 shadow-[0_0_15px_rgba(0,194,255,0.3)]"
              : "bg-white/5 text-white/60 border border-white/10 hover:bg-white/10 hover:text-white/80"
          )}
        >
          {category}
        </button>
      ))}
    </div>
  );
};
